// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tip-video-play-modal .add-section-modal{background:none}", "",{"version":3,"sources":["webpack://src/pages/stores/components/Tip.vue"],"names":[],"mappings":"AAAA,yCAAyC,eAAe","sourcesContent":[".tip-video-play-modal .add-section-modal{background:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
